import { Injectable, inject } from '@angular/core';
import { User, UsersService } from '@era/security-sdk';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AuthorizationService, Permissions } from '@rocksoft/shared/authorization';
import { mergeMap } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';
import { SuggestedUserApiActions, UserResolverActions } from './suggested-user.actions';

@Injectable()
export class SuggestedUserEffects {
  private readonly userService = inject(UsersService);
  private readonly actions$ = inject(Actions);
  private readonly authorizationService = inject(AuthorizationService);

  suggestedUserLoadedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserResolverActions.suggestedUsersRequested),
      mergeMap(() =>
        safeMap(
          () => {
            if (!this.authorizationService.getIsAuthorized(Permissions.SecurityListAzureUsers)) {
              throw Error('Tried to load suggested users while unauthorized.');
            }
            return this.userService.searchForNewUsers();
          },
          (suggestedUsers: User[]) => SuggestedUserApiActions.suggestedUsersLoaded({ suggestedUsers }),
          (error) => SuggestedUserApiActions.errorLoadingSuggestedUsers({ error })
        )
      )
    );
  });
}
